import React from 'react';
import ReactDOM from 'react-dom';
import CookieBanner from 'react-cookie-banner';

import App from './App';
import './semantic.min.css';
import './index.css';

ReactDOM.render(
  <CookieBanner
    disableStyle
    className="banner"
    message="Ce site utilise Google Analytics. En continuant à naviguer, vous nous autorisez à déposer un cookie à des fins de mesure d'audience."
    onAccept={() => {}}
    cookie="user-has-accepted-cookies"
    dismissOnScroll={false}
    buttonMessage="Ok"
  />,
  document.getElementById('banner')
);
document.getElementById('loading-spinner').remove();
ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js